export default __webpack_public_path__ + "static/media/PANTALLAZOS_3.bf77f952.jpg";